<template>
  <!-- MODAL DE GESTIÓN DE TURNOS -->
  <div class="calendar-index-app">
    <div v-if="showCustomModal" class="absolute-position">
      <div class="custom-modal" ref="customModal">
        <div class="header">
          <h2>{{ headerDate }}</h2>
        </div>
        <div class="body" :key="prodLineInfo.length">
          <div class="prod-line-buttons">
            <button v-for="pl in dayShiftInfo" :key="pl.id" class="btn btn-secondary prod-line-button" :class="{'selected-button': pl.id === currentProdLine.id}" @click="selectedProdLine(pl)">
              {{ pl.name }}
            </button>
          </div>
          <div class="shifts">
            <div v-if=" currentProdLine.length === 0" class="no-info-message">
              <p>Selecciona una línea de producción</p>
            </div>
            <div v-else-if="prodLineInfo.length === 0 && currentProdLine.id > 0" class="no-info-message">
              <p>Línea de producción sin turnos</p>
            </div>
            <table v-else-if="prodLineInfo.length > 0" class="shifts-tables">
              <thead>
                <tr>
                  <th>Tipo</th>
                  <th>Descripción</th>
                  <th>Hora de inicio</th>
                  <th>Hora de fin</th>
                  <th v-if="showActions && !onlyView" class="actions-shifts-buttons">Acciones</th>
                </tr>
              </thead>
                <tbody>
                    <tr v-for="(is, index) in prodLineInfo" :key="index" :style="{ backgroundColor: is.type === 'Turno' ? '' : is.type === 'Parada' ? 'rgba(255, 150, 0, 0.4)' : 'rgba(96, 178, 245, 0.4)' }">
                    <td>{{ is.type }}</td>
                    <td>{{ is.description }}</td>
                    <td>{{ is.start_time }}</td>
                    <td>{{ is.end_time }}</td>
                    <td v-if="showActions && !onlyView" class="actions-shifts-buttons">
                      <button v-if="canEditShift(is)" class="btn btn-dark" @click="openEditModal(is)">Editar</button>
                      <button v-if="canEditStop(is)" class="btn btn-dark" @click="openEditModal(is)">Editar</button>
                      <button v-if="canDeleteShift(is)" class="btn btn-danger" @click="confirmDelete(is)">Eliminar</button>
                      <button v-if="canDeleteStop(is)" class="btn btn-danger" @click="confirmDelete(is)">Eliminar</button>
                    </td>
                  </tr>
                </tbody>
            </table>
            <div v-if="!onlyView" class="prod-line-actions-buttons" :class="isVisible ? 'visible' : 'hidden'">
              <button v-if="canGenerateShift" class="btn btn-primary primary-button" @click="openCreateShiftModal" >Añadir turno</button>
              <span v-if="canGenerateShift" >|</span>
              <button v-if="canGenerateShiftsByProdLine" class="btn btn-primary primary-button" @click="confirmGenerateAllShiftsByProdLine" >Generar turnos</button>
              <button v-if="prodLineInfo.length > 0 && canDeleteShiftsByProdLine" class="btn btn-danger danger-button" @click="confirmDeleteAllShiftsByProdLine" >Borrar turnos</button>
            </div>
          </div>
        </div>
        <div class="footer">
          <div class="footer-buttons">
            <div class="general-action-buttons">
              <button v-if="canGenerateShiftsByInterval && !onlyView" class="btn btn-primary primary-button" @click="confirmGenerateAllShiftsAllProdLines" >Generar turnos</button>
              <button v-if="existsDayShiftInfo && canDeleteAllShiftsAllProdLines  && !onlyView" class="btn btn-danger danger-button" @click="confirmDeleteAllShiftsAllProdLines" >Borrar turnos</button>
            </div>
            <button class="btn btn-danger" @click="closeCustomModal">Cerrar</button>
          </div>
        </div>
      </div>
    </div>

    <!-- MODAL DE CREACIÓN DE TURNO -->
    <b-modal v-model="showCreateShiftModal" title="Crear turno" hide-footer>
      <b-form @submit.prevent="createShift">
        <div>
          <b-form-group label="Descripción:" label-for="create_description" label-cols="4">
            <b-form-input id="create_description" v-model="newShift.description" required></b-form-input>
          </b-form-group>
          <b-form-group label="Hora de inicio:" label-for="create_start_time" label-cols="4">
            <b-form-timepicker id="create_start_time" v-model="newShift.start_time" required></b-form-timepicker>
          </b-form-group>
          <b-form-group label="Hora de fin:" label-for="create_end_time" label-cols="4">
            <b-form-timepicker id="create_end_time" v-model="newShift.end_time" required></b-form-timepicker>
          </b-form-group>
          <div class="is-extra-shift-checkbox">
            <label class="form-label me-3">Es turno extra</label>
            <label class="form-check form-switch">
              <input type="checkbox" v-model="newShift.is_extra_shift" class="form-check-input">
            </label>
          </div>
        </div>
        <hr>
        <div class="action-buttons">
          <b-button type="submit" class="btn btn-primary primary-button">Guardar</b-button>
          <b-button class="btn btn-danger" @click="closeCreateShiftModal">Cerrar</b-button>
        </div>
      </b-form>
    </b-modal>

    <!-- MODAL DE GENERACIÓN DE TURNOS -->
    <b-modal v-model="showGenerateCalendarModal" title="Seleccionar rango de fechas" hide-footer>
      <b-form @submit.prevent="confirmGenerateShiftsCalendar">
        <div>
          <b-form-group label="Fecha de inicio:" label-for="start_date" label-cols="4">
            <b-form-input id="start_date" v-model="rangeDates.start_date" type="date" required :min="minDate"></b-form-input>
          </b-form-group>
          <b-form-group label="Fecha de fin:" label-for="end_date" label-cols="4">
            <b-form-input id="end_date" v-model="rangeDates.end_date" type="date" required :min="minDate"></b-form-input>
          </b-form-group>
        </div>
        <hr>
        <div class="action-buttons">
          <b-button type="submit" class="btn btn-primary primary-button">Generar</b-button>
          <b-button class="btn btn-danger" @click="closeDateRangeModal">Cerrar</b-button>
        </div>
      </b-form>
    </b-modal>

    <!-- MODAL DE BORRADO DE TURNOS -->
    <b-modal v-model="showDeleteShiftsModal" title="Seleccionar rango de fechas" hide-footer>
      <b-form @submit.prevent="confirmDeleteShiftsCalendar">
        <div>
          <b-form-group label="Fecha de inicio:" label-for="delete_start_date" label-cols="4">
            <b-form-input id="delete_start_date" v-model="rangeDates.start_date" type="date" required></b-form-input>
          </b-form-group>
          <b-form-group label="Fecha de fin:" label-for="delete_end_date" label-cols="4">
            <b-form-input id="delete_end_date" v-model="rangeDates.end_date" type="date" required></b-form-input>
          </b-form-group>
        </div>
        <hr>
        <div class="action-buttons delete-buttons">
          <div>
            <b-button class="btn btn-secondary close-button" @click="closeDeleteShiftsModal">Cerrar</b-button>
            <b-button type="submit" class="btn btn-danger danger-button">Borrar</b-button>
          </div>
        </div>
      </b-form>
    </b-modal>

    <!-- MODAL DE EDICIÓN DE TURNO -->
    <b-modal v-model="showEditModal" :title="selectedShift.isStop ? 'Editar parada' : 'Editar turno'" hide-footer>
      <b-form @submit.prevent="selectedShift.isStop ? editStop() : editShift()">
        <div>
          <b-form-group label="Descripción:" label-for="description" label-cols="4">
            <b-form-input id="description" v-model="selectedShift.description" required></b-form-input>
          </b-form-group>
          <b-form-group label="Hora de inicio:" label-for="start_time" label-cols="4">
            <b-form-timepicker id="start_time" v-model="selectedShift.start_time" required></b-form-timepicker>
          </b-form-group>
          <b-form-group label="Hora de fin:" label-for="end_time" label-cols="4">
            <b-form-timepicker id="end_time" v-model="selectedShift.end_time" required></b-form-timepicker>
          </b-form-group>
        </div>
        <div v-if="!selectedShift.isStop && showAddStopModal">
          <hr>
          <b-form @submit.prevent="createStop">
            <b-form-group label="Descripción:" label-for="new_description" label-cols="4">
              <b-form-input id="new_description" v-model="newStop.description" required></b-form-input>
            </b-form-group>
            <b-form-group label="Hora de inicio:" label-for="new_start_time" label-cols="4">
              <b-form-timepicker id="new_start_time" v-model="newStop.start_time" required></b-form-timepicker>
            </b-form-group>
            <b-form-group label="Hora de fin:" label-for="new_end_time" label-cols="4">
              <b-form-timepicker id="new_end_time" v-model="newStop.end_time" required></b-form-timepicker>
            </b-form-group>
            <div class="action-buttons">
              <b-button class="btn btn-danger mt-3" @click="closeAddStopModal">Cancelar</b-button>
              <b-button type="submit" class="btn btn-primary primary-button mt-3">Guardar parada</b-button>
            </div>
          </b-form>
        </div>
        <hr>
        <div class="action-buttons">
          <b-button v-if="canAddStop" class="btn btn-block secondary-button" @click="openAddStopModal">Añadir parada</b-button>
          <b-button type="submit" class="btn btn-primary primary-button">Guardar</b-button>
          <b-button class="btn btn-danger" @click="closeEditModal">Cerrar</b-button>
        </div>
      </b-form>
    </b-modal>
    
    <!-- CALENDARIO -->
    <div>
      <div class="main-calendar">
        <FullCalendar ref="fullCalendar" :options='calendarOptions' />
      </div>
    </div>
  </div> 
</template>

<script>
import axios from 'axios'
import Swal from 'sweetalert2';
import { mapGetters } from 'vuex';
import FullCalendar from '@fullcalendar/vue'
import dayGridPlugin from '@fullcalendar/daygrid'
import esLocale from '@fullcalendar/core/locales/es'
import multiMonthPlugin from '@fullcalendar/multimonth'
import interactionPlugin from '@fullcalendar/interaction'
import { showCustomErrorSweetAlert, showCustomSuccessSweetAlert } from '../../common/utils';
import PermissionConsts from '../../common/permissions';

export default {
  name: 'CalendarIndex',
  components: {
    FullCalendar,
  },
  data() {
    return {
      calendarOptions: {
        plugins: [dayGridPlugin, multiMonthPlugin, interactionPlugin],
        initialView: 'multiMonthYear',
        customButtons: {
          configuration: {
            text: 'Ajustar plantillas',
            click: this.handleConfigurationButtonClick
          },
          generateShifts: {
            text: 'Generar turnos',
            click: this.handleGenerateShiftsButtonClick
          },
          deleteShifts: {
            text: 'Borrar turnos',
            click: this.confirmDeleteAllShifts
          }
        },
        views: {
          multiMonthYear: {
            type: 'multiMonth',
            duration: { years: 1 },
            multiMonthMaxColumns: 4,
            multiMonthMinWidth: 200,
          },
        },
        weekends: true,
        events: [],
        locale: esLocale,
        dayHeaderFormat: { weekday: 'narrow' },
        selectable: true,
        unselectAuto: false,
        dateClick: this.handleDateClick,
        datesSet: this.handleDatesSet,
        validRange: {
          start: new Date().getFullYear() + '-01-01',
        },  
      },
      shifts: [],
      dayShiftInfo: [],
      headerDate: '',
      selectedShift: [],
      prodLineInfo: [],
      currentProdLine: [],
      currentDate: '',
      currentYear: '',
      showCustomModal: false,
      showEditModal: false,
      showAddStopModal: false,
      showCreateShiftModal: false,
      showGenerateCalendarModal: false,
      showDeleteShiftsModal: false,
      onlyView: false,
      minDate: this.getActualDate(),
      formEdit: {},
      newStop: {
        description: '',
        start_time: '00:00:00',
        end_time: '00:00:00',
        shifts_individual_id: '',
      },
      newShift: {
        description: '',
        start_time: '00:00:00',
        end_time: '00:00:00',
        is_extra_shift: true,
        production_line_id: -1,
        date: '',
      },
      rangeDates: {
        start_date: '',
        end_date: this.getLastDayYear(),
        production_line_id: null,
      },
    };
  },
  methods: {
    // GETS
    getActualDate(){
      let today = new Date();
      today.setDate(today.getDate() + 1);
      let year = today.getFullYear();
      let month = String(today.getMonth() + 1).padStart(2, "0");
      let day = String(today.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    },
    getLastDayYear(){
      let today = new Date();
      let year = today.getFullYear();
      return `${year}-12-31`;
    },
    async getShifts() {
      try {
        let response = await axios.get(`/api/shifts-individual`);
        this.shifts = await response.data;
        await this.paintDays();
      } catch (error) {
        showCustomErrorSweetAlert(error.response.data);
      }
    },
    async getDayShifts(formattedDate) {
      try {
        let response = await axios.get(`/api/shifts-individual/${formattedDate}/by-date/grouped-by-pl`);
        this.dayShiftInfo = await response.data;
      } catch (error) {
        showCustomErrorSweetAlert(error.response.data);
      }
    },
    async refreshData(){
      if (this.currentDate != '' && this.currentProdLine) {
        await this.getDayShifts(this.currentDate);
        let prodLine = this.dayShiftInfo.find(pl => pl.id === this.currentProdLine.id);
        if (prodLine) {
          this.selectedProdLine(prodLine);
        }
      }
    },

    // CREATES
    createStop(){
      this.newStop.shifts_individual_id = this.selectedShift.id;
      if (this.newStop.start_time >= this.newStop.end_time){
        Swal.fire({
          icon: 'warning',
          title: 'La hora de inicio debe ser menor a la hora de fin',
          showConfirmButton: false,
          timer: 3000
        });
        return;
      }
      if (this.newStop.start_time < this.selectedShift.start_time || this.newStop.end_time > this.selectedShift.end_time){
        Swal.fire({
          icon: 'warning',
          title: 'La parada debe estar dentro del rango del turno',
          showConfirmButton: false,
          timer: 3000
        });
        return;
      }
      axios.post(`/api/stops-individual`, this.newStop)
        .then(response => {
          showCustomSuccessSweetAlert('Parada creada correctamente');
          this.closeAddStopModal();
          this.refreshData();
        })
        .catch(error => {
          if (error.response.data.errorMessage.includes('rango de tiempo')) {
            Swal.fire({
              icon: 'warning',
              title: 'Ya existe una parada en ese rango de horas',
              showConfirmButton: false,
              timer: 3000
            });
          } else {
            showCustomErrorSweetAlert(error.response.data);
          }
        });
    },
    createShift(){
      this.newShift.date = this.currentDate;
      this.newShift.production_line_id = this.currentProdLine.id;
      if (this.newShift.start_time >= this.newShift.end_time){
        Swal.fire({
          icon: 'warning',
          title: 'La hora de inicio debe ser menor a la hora de fin',
          showConfirmButton: false,
          timer: 3000
        });
        return;
      }
      axios.post(`/api/shifts-individual/generate/extra`, this.newShift)
        .then(response => {
          showCustomSuccessSweetAlert('Turno creado correctamente');
          this.reloadDays();
          this.closeCreateShiftModal();
          this.clearNewShift();
        })
        .catch(error => {
            if (error.response.data.errorMessage.includes('rango de tiempo')) {
            Swal.fire({
              icon: 'warning',
              title: 'Ya existe un turno en ese rango de horas',
              showConfirmButton: false,
              timer: 3000
            });
          } else {
            showCustomErrorSweetAlert(error.response.data);
          }
        });
    },
    generateAllShiftsAllProdLines(){
      let formData = {
        start_date: this.currentDate,
        end_date: this.currentDate,
        production_line_id: null,
      }
      axios.post(`/api/shifts-individual/generate`, formData)
        .then(response => {
          showCustomSuccessSweetAlert('Turnos generados correctamente');
          this.reloadDays();
          this.clearGenerateShiftsData();
        })
        .catch(error => {
          showCustomErrorSweetAlert(error.response.data);
        });
    },
    generateAllShiftsByProdLine(){
      let formData = {
        start_date: this.currentDate,
        end_date: this.currentDate,
        production_line_id: this.currentProdLine.id,
      }
      axios.post(`/api/shifts-individual/generate/by-prod-line`, formData)
        .then(response => {
          showCustomSuccessSweetAlert('Turnos generados correctamente');
          this.reloadDays();
          this.clearGenerateShiftsData();
        })
        .catch(error => {
          showCustomErrorSweetAlert(error.response.data);
        });
    },
    generateShiftsCalendar(){
      axios.post(`/api/shifts-individual/generate`, this.rangeDates)
        .then(response => {
          showCustomSuccessSweetAlert('Turnos generados correctamente');
          this.reloadDays();
          this.closeDateRangeModal();
          this.clearGenerateShiftsData();
        })
        .catch(error => {
          showCustomErrorSweetAlert(error.response.data);
        });
    },

    // DELETES
    deleteShift(shift){
      axios.delete(`/api/shifts-individual/${shift.id}`)
        .then(response => {
          showCustomSuccessSweetAlert('Turno eliminado correctamente');
          this.reloadDays();
        })
        .catch(error => {
          showCustomErrorSweetAlert(error.response.data);
        });
    },
    deleteStop(stop){
      axios.delete(`/api/stops-individual/${stop.id}`)
        .then(response => {
          showCustomSuccessSweetAlert('Parada eliminada correctamente');
          this.reloadDays();
        })
        .catch(error => {
          showCustomErrorSweetAlert(error.response.data);
        });
    },
    deleteAllShiftsAllProdLine(){
      axios.delete(`/api/shifts-individual/${this.currentDate}/delete-all-pl`)
        .then(response => {
          showCustomSuccessSweetAlert('Turnos eliminados correctamente');
          this.reloadDays();
        })
        .catch(error => {
          showCustomErrorSweetAlert(error.response.data);
        });
    },
    deleteAllShiftsByProdLine(){
      axios.delete(`/api/shifts-individual/${this.currentDate}/by-prod-line/${this.currentProdLine.id}`)
        .then(response => {
          showCustomSuccessSweetAlert('Turnos eliminados correctamente');
          this.reloadDays();
        })
        .catch(error => {
          showCustomErrorSweetAlert(error.response.data);
        });
    },
    deleteAllShiftsByInterval(){
      axios.delete(`/api/shifts-individual`, {data: this.rangeDates})
        .then(response => {
          showCustomSuccessSweetAlert('Turnos eliminados correctamente');
          this.reloadDays();
          this.closeDeleteShiftsModal();
        })
        .catch(error => {
          showCustomErrorSweetAlert(error.response.data);
        });
    },

    // UPDATES
    editShift(){
      this.formEdit = {
        new_start_time: this.selectedShift.start_time,
        new_end_time: this.selectedShift.end_time,
        new_description: this.selectedShift.description,
      }
      if (this.selectedShift.start_time >= this.selectedShift.end_time){
        Swal.fire({
          icon: 'warning',
          title: 'La hora de inicio debe ser menor a la hora de fin',
          showConfirmButton: false,
          timer: 3000
        });
        return;
      }
      axios.patch(`/api/shifts-individual/${this.selectedShift.id}`, this.formEdit)
        .then(response => {
          showCustomSuccessSweetAlert('Turno actualizado correctamente');
          this.closeEditModal();
          this.refreshData();
        })
        .catch(error => {
          showCustomErrorSweetAlert(error.response.data);
        });
    },
    editStop(){
      this.formEdit = {
        new_start_time: this.selectedShift.start_time,
        new_end_time: this.selectedShift.end_time,
        new_description: this.selectedShift.description,
      }
      if (this.selectedShift.start_time >= this.selectedShift.end_time){
        Swal.fire({
          icon: 'warning',
          title: 'La hora de inicio debe ser menor a la hora de fin',
          showConfirmButton: false,
          timer: 3000
        });
        return;
      }
      axios.patch(`/api/stops-individual/${this.selectedShift.id}`, this.formEdit)
        .then(response => {
          showCustomSuccessSweetAlert('Parada actualizada correctamente');
          this.closeEditModal();
          this.refreshData();
        })
        .catch(error => {
          showCustomErrorSweetAlert(error.response.data);
        });
    },

    // UTILS
    clearGenerateShiftsData(){
      this.rangeDates = {
        start_date: '',
        end_date: '',
        production_line_id: null,
      };
    },
    clearNewShift(){
      this.newShift = {
        description: '',
        start_time: '00:00:00',
        end_time: '00:00:00',
        is_extra_shift: true,
        production_line_id: -1,
        date: '',
      };
    },
    closeCustomModal(){
      this.onlyView = false;
      this.showCustomModal = false;
      this.prodLineInfo = [];
      this.currentProdLine = [];  
    },
    closeEditModal(){
      this.showEditModal = false;
      this.showAddStopModal = false;
      this.newStop = {};
    },
    openEditModal(shift){
      this.showEditModal = true;
      this.selectedShift = {...shift};
    },
    openAddStopModal(){
      this.newStop.start_time = this.selectedShift.start_time;
      this.newStop.end_time = this.selectedShift.end_time;
      this.showAddStopModal = true;
    },
    closeAddStopModal(){
      this.showAddStopModal = false;
      this.newStop = {
        description: '',
        start_time: '00:00:00',
        end_time: '00:00:00',
        shifts_individual_id: '',
      };
    },
    openCreateShiftModal(){
      this.showCreateShiftModal = true;
    },
    closeCreateShiftModal(){
      this.showCreateShiftModal = false;
      this.clearNewShift();
    },
    closeDateRangeModal(){
      this.showGenerateCalendarModal = false;
    },
    closeDeleteShiftsModal(){
      this.showDeleteShiftsModal = false;
    },
    confirmDelete(element){
      Swal.fire({
        title: '¿Estás seguro?',
        text: element.isStop ? `¡Estás a punto de borrar esta parada!` : `¡Estás a punto de borrar este turno!`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: 'red',
        cancelButtonColor: 'gray',
        confirmButtonText: element.isStop ? 'Sí, borrar parada' : 'Sí, borrar turno',
        cancelButtonText: 'Cancelar',
      }).then(result => {
        if (result.isConfirmed) {
          element.isStop ? this.deleteStop(element) : this.deleteShift(element);
        }
      });
    },
    confirmDeleteAllShiftsAllProdLines(){
      Swal.fire({
        title: '¿Estás seguro?',
        text: `¡Estás a punto de borrar todos los turnos de esta fecha ${this.currentDate}!`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: 'red',
        cancelButtonColor: 'gray',
        confirmButtonText: 'Sí, borrar turnos',
        cancelButtonText: 'Cancelar',
      }).then(result => {
        if (result.isConfirmed) {
          this.deleteAllShiftsAllProdLine();
        }
      });
    },
    confirmDeleteAllShiftsByProdLine(){
      Swal.fire({
        title: '¿Estás seguro?',
        text: `¡Estás a punto de borrar todos los turnos de la línea de producción ${this.currentProdLine.name} de esta fecha ${this.currentDate}!`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: 'red',
        cancelButtonColor: 'gray',
        confirmButtonText: 'Sí, borrar turnos',
        cancelButtonText: 'Cancelar',
      }).then(result => {
        if (result.isConfirmed) {
          this.deleteAllShiftsByProdLine();
        }
      });
    },
    confirmGenerateAllShiftsAllProdLines(){
      Swal.fire({
        title: '¿Estás seguro?',
        text: `¡Estás a punto de generar todos los turnos de esta fecha ${this.currentDate}!`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: 'green',
        cancelButtonColor: 'red',
        confirmButtonText: 'Sí, generar turnos',
        cancelButtonText: 'Cancelar',
      }).then(result => {
        if (result.isConfirmed) {
          this.generateAllShiftsAllProdLines();
        }
      });
    },
    confirmGenerateAllShiftsByProdLine(){
      Swal.fire({
        title: '¿Estás seguro?',
        text: `¡Estás a punto de generar todos los turnos de la línea de producción ${this.currentProdLine.name} de esta fecha ${this.currentDate}!`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: 'green',
        cancelButtonColor: 'red',
        confirmButtonText: 'Sí, generar turnos',
        cancelButtonText: 'Cancelar',
      }).then(result => {
        if (result.isConfirmed) {
          this.generateAllShiftsByProdLine();
        }
      });
    },
    confirmGenerateShiftsCalendar(){
      if (!this.checkRanges()) return;
      Swal.fire({
        title: '¿Estás seguro?',
        text:`¡Estás a punto de generar turnos del ${this.rangeDates.start_date} al ${this.rangeDates.end_date}!`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: 'green',
        cancelButtonColor: 'red',
        confirmButtonText: 'Sí, generar turnos',
        cancelButtonText: 'Cancelar',
      }).then(result => {
        if (result.isConfirmed) {
          Swal.fire({
            title: 'Generando turnos',
            text: 'Este proceso puede tardar un poco, por favor espere...',
            icon: 'info',
            showConfirmButton: false,
            allowOutsideClick: false,
            allowEscapeKey: false,
            willOpen: () => {
              Swal.showLoading();
            }
          });
          this.generateShiftsCalendar();
        }
      });
    },
    confirmDeleteShiftsCalendar(){
      if (!this.checkRanges()) return;
      Swal.fire({
        title: '¿Estás seguro?',
        text: `¡Estás a punto de borrar todos los turnos del ${this.rangeDates.start_date} al ${this.rangeDates.end_date}!`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: 'red',
        cancelButtonColor: 'gray',
        confirmButtonText: 'Sí, borrar turnos',
        cancelButtonText: 'Cancelar',
      }).then(result => {
        if (result.isConfirmed) {
          this.deleteAllShiftsByInterval();
        }
      });
    },
    confirmDeleteAllShifts(){
      if (this.existsShifts){
        this.setRangeDates();
        this.showDeleteShiftsModal = true;
        return;
      } 
      Swal.fire({
        icon: 'warning',
        title: 'No hay turnos para borrar',
        showConfirmButton: false,
        timer: 3000
      });
    },
    handleGenerateShiftsButtonClick() {
      this.setRangeDates();
      this.showGenerateCalendarModal = true;
      return;
    },
    selectedProdLine(pl) {
      this.currentProdLine = pl;
      this.prodLineInfo = pl.shiftsIndividuals
        .filter(shift => shift) 
        .map(shift => {
          const mainShift = {
            id: shift.id,
            isStop: false,
            description: shift.description,
            start_time: shift.start_time,
            end_time: shift.end_time,
            date: shift.date,
            type: shift.is_extra_shift ? 'Turno extra' : 'Turno',
          };

          const stops = shift.stops_individuals.map(stop => ({
            id: stop.id,
            isStop: true,
            description: stop.description,
            start_time: stop.start_time,
            end_time: stop.end_time,
            date: stop.date,
            type: 'Parada',
          }));

          return [mainShift, ...stops];
        })
        .flat() 
        .sort((a, b) => a.start_time.localeCompare(b.start_time)); 
    },
    handleDateClick(info) {
      const clickedDate = info.date;
      const formattedDate = this.formatDate(clickedDate);
              
      const today = new Date();
      today.setHours(0, 0, 0, 0); 

      if (clickedDate <= today || !this.canAccessToShifts) {
        this.onlyView = true;
      }
      let date = new Date(formattedDate);
      this.headerDate = 
        date.toLocaleDateString("es-ES", {
          weekday: "long",
          year: "numeric",
          month: "long",
          day: "numeric",
        });
      this.showCustomModal = true;
      this.currentDate = formattedDate;
      this.getDayShifts(formattedDate);
    },
    async paintDays() {
      let calendarApi = this.$refs.fullCalendar.getApi();
      let allDates = calendarApi.el.querySelectorAll('.fc-daygrid-day');
      let today = new Date().toISOString().split('T')[0];
      allDates.forEach(dateElement => {
        let date = dateElement.getAttribute('data-date');
        let dayNumber = dateElement.querySelector('.fc-daygrid-day-number');
        let classList = dayNumber.classList;
        if (classList.contains('day-has-shift'))        classList.remove('day-has-shift');
        if (classList.contains('day-has-extra-shift'))  classList.remove('day-has-extra-shift');
        if (date <= today) {
          classList.add('no-selectable');
          return;
        }
        let shift = this.shifts.find(shift => shift.date === date && shift.is_extra_shift) || this.shifts.find(shift => shift.date === date);
        if (shift) {
          this.paintDate(dateElement, shift.is_extra_shift);
        }
      });
    },
    paintDate(element, extraShift) {
      element.style.backgroundColor = '#d9edf7';
      let dayNumber = element.querySelector('.fc-daygrid-day-number');
      if (dayNumber) {
        let classList = dayNumber.classList;
        if (extraShift)   classList.add('day-has-extra-shift');
        if (!extraShift)  classList.add('day-has-shift');
      }
    },
    formatDate(date) {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0'); 
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    },
    handleDatesSet() {
      this.currentYear = this.$refs.fullCalendar.getApi().getDate().getFullYear();
      this.$nextTick(() => {
          this.paintDays();
      });
    },
    handleConfigurationButtonClick() {
      window.location.href = '/calendar/shifts-templates';
    },
    setRangeDates(){
      let actualYear = new Date().getFullYear();
      if (this.currentYear === actualYear) {
        this.rangeDates.start_date = this.getActualDate();
        this.rangeDates.end_date = this.getLastDayYear();
      } else {
        this.rangeDates.start_date = `${this.currentYear}-01-01`;
        this.rangeDates.end_date = `${this.currentYear}-12-31`;
      }
    },
    checkRanges(){
      const startYear = new Date(this.rangeDates.start_date).getFullYear();
      const endYear = new Date(this.rangeDates.end_date).getFullYear();
      if (startYear !== this.currentYear || endYear !== this.currentYear) {
      Swal.fire({
        icon: 'warning',
        title: 'El rango de fechas debe estar dentro del año actual',
        showConfirmButton: false,
        timer: 3000
      });
      return false;
      }
      return true;
    },
    reloadDays(){
      this.getShifts();
      this.refreshData();
    },
    buttons(){
      let buttonse = this.buttonse;
      let calendarApi = this.$refs.fullCalendar.getApi();
      calendarApi.setOption('headerToolbar', {
        left: 'prev,title,next',
        right: buttonse,
      });
    },
    canEditShift(is){
      return (!is.isStop && this.userHasPermission(PermissionConsts.SHIFTS_INDIVIDUAL_UPDATE));
    },
    canEditStop(is){
      return (is.isStop && this.userHasPermission(PermissionConsts.STOPS_INDIVIDUAL_UPDATE));
    },
    canDeleteShift(is){
      return (!is.isStop && this.userHasPermission(PermissionConsts.SHIFTS_INDIVIDUAL_DELETE));
    },
    canDeleteStop(is){
      return (is.isStop && this.userHasPermission(PermissionConsts.STOPS_INDIVIDUAL_DELETE));
    },
  },
  computed: {
    ...mapGetters(['userPermissions','userHasPermission','isUserSuperadmin']),
    isVisible(){
      return this.currentProdLine.id > 0;
    },
    existsDayShiftInfo(){
      return this.dayShiftInfo.some(pl => pl.shiftsIndividuals.length > 0);
    },
    existsShifts(){
      return this.shifts.some(shift => new Date(shift.date).getFullYear() === this.currentYear);
    },
    canAddStop(){
      return (!this.selectedShift.isStop && this.isUserSuperadmin);
    },
    canViewTemplates(){
      return this.userHasPermission(PermissionConsts.SHIFT_TEMPLATE_INDEX_VIEW);
    },
    canGenerateShiftsByInterval(){
      return this.userHasPermission(PermissionConsts.SHIFTS_INDIVIDUAL_BY_DATE_INTERVAL_GENERATE);
    },
    canDeleteShiftsByInterval(){
      return this.userHasPermission(PermissionConsts.SHIFTS_INDIVIDUAL_BY_DATE_INTERVAL_DELETE);
    },
    showActions(){
      return (this.userHasPermission(PermissionConsts.SHIFTS_INDIVIDUAL_UPDATE) || this.userHasPermission(PermissionConsts.STOPS_INDIVIDUAL_UPDATE)
      || this.userHasPermission(PermissionConsts.SHIFTS_INDIVIDUAL_DELETE) || this.userHasPermission(PermissionConsts.STOPS_INDIVIDUAL_DELETE));
    },
    canGenerateAllShiftAllProdLines(){
      return this.userHasPermission(PermissionConsts.SHIFTS_INDIVIDUAL_GENERATE);
    },
    canDeleteAllShiftsAllProdLines(){
      return this.userHasPermission(PermissionConsts.SHIFTS_INDIVIDUAL_AT_DATE_ALL_PL_DELETE);
    },
    canGenerateShift(){
      return this.userHasPermission(PermissionConsts.SHIFTS_INDIVIDUAL_EXTRA_SHIFT_GENERATE);
    },
    canGenerateShiftsByProdLine(){
      return this.userHasPermission(PermissionConsts.SHIFTS_INDIVIDUAL_BY_DATE_INTERVAL_BY_PL_GENERATE);
    },
    canDeleteShiftsByProdLine(){
      return this.userHasPermission(PermissionConsts.SHIFTS_INDIVIDUAL_AT_DATE_BY_PL_DELETE);
    },
    canAccessToShifts(){
      return this.userHasPermission(PermissionConsts.SHIFTS_INDIVIDUAL_BY_DATE_GROUPED_BY_PL_GET);
    },
    buttonse(){
      let buttons = '';
      if (this.canViewTemplates) {
        if (buttons === '') {
          buttons += 'configuration';
        } else {
          buttons += ' configuration';
        }
      };
      if (this.canGenerateShiftsByInterval) {
        if (buttons === '') {
          buttons += 'generateShifts';
        } else {
          buttons += ' generateShifts';
        }
      };
      if (this.canDeleteShiftsByInterval) {
        if (buttons === '') {
          buttons += 'deleteShifts';
        } else {
          buttons += ' deleteShifts';
        }
      };
      return buttons;
    },
  },
  mounted() {
    this.buttons();
    this.getShifts();
  },
  watch: {
    userPermissions: {
      handler: function(){
        this.buttons();
      },
      deep: true,
    },
  }
};
</script>